import React from 'react';
import { Text } from 'quanta-ui';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

var Loading = function Loading(_ref) {
  var customMessage = _ref.customMessage,
      textSize = _ref.textSize,
      textColor = _ref.textColor,
      textOpacity = _ref.textOpacity,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(Text, {
    type: textSize ? textSize : 'larger',
    className: className ? className : "flex flex-row justify-center items-center space-x-2 py-12 ".concat(textOpacity ? "".concat(textOpacity) : 'text-opacity-50', " ").concat(textColor ? "".concat(textColor) : 'text-primary', " w-full")
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faSpinner,
    spin: true
  })), /*#__PURE__*/React.createElement("span", null, customMessage ? customMessage : 'Loading'));
};

export { Loading as L };
